import React, { Suspense, useEffect, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import OldRoutes from "./routes/OldRoutes";
import { Loading } from "../pages/Loading";
import NewRoutes from "./routes/NewRoutes";
import { Org, Workspace } from "../types/org";
import { User } from "../types/user";

const Entree = React.lazy(() => import("../pages/Entree"));
const Login = React.lazy(() => import("../pages/Login"));
const Redirect = React.lazy(() => import("../pages/Redirect"));
const Setup = React.lazy(() => import("../pages/Setup"));
const Signin = React.lazy(() => import("../pages/Signin"));
const NotFound = React.lazy(() => import("../pages/NotFound"));

type RoutesManagerProps = {
  navigateWorkspace: (...args: any[]) => void;
  actualpage?: any;
  userData?: User | null;
  orgData?: Org | null;
  handleLoginAs?: (...args: any[]) => void;
  handleLogout?: (...args: any[]) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
  setShowProtocole?: (page: number) => void; // Optional prop to control protocol visibility
  workspaceData?: Workspace | null;
  masterData?: Org | null;
};

const RoutesManager: React.FC<RoutesManagerProps> = ({
  navigateWorkspace,
  actualpage,
  userData,
  orgData,
  masterData,
  handleLoginAs,
  workspaceData,
  handleLogout,
  handleClickVariant,
  setShowProtocole,
}) => {
  return (
    <div className="pointer-events-auto h-full w-full overflow-auto">
      <Routes>
        <Route
          path="/"
          element={<Redirect navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/entree"
          element={<Entree navigateWorkspace={navigateWorkspace} userData={userData} />}
        />
        <Route
          path="/login"
          element={
            <Login
              userData={userData}
              navigateWorkspace={navigateWorkspace}
              handleLogout={handleLogout}
            />
          }
        />
        <Route
          path="/signin"
          element={<Signin navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/setup"
          element={<Setup navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/*"
          element={
            <OldRoutes
              navigateWorkspace={navigateWorkspace}
              actualpage={actualpage}
              userData={userData}
              orgData={orgData}
              workspaceData={workspaceData}
              handleLoginAs={handleLoginAs}
              masterData={masterData}
              handleClickVariant={handleClickVariant}
            ></OldRoutes>
          }
        />{" "}
        <Route
          path="/workspace/:id/*"
          element={
            <NewRoutes
              navigateWorkspace={navigateWorkspace}
              actualpage={actualpage}
              userData={userData}
              orgData={orgData}
              workspaceData={workspaceData}
              masterData={masterData}
            ></NewRoutes>
          }
        />
        <Route
          path="*"
          element={<NotFound navigateWorkspace={navigateWorkspace} />}
        />
      </Routes>
    </div>
  );
};

export default RoutesManager;
